import { GraficoComponent } from './home/Components/grafico.component';
import { FaqValorizaComponent } from './home/Faqs/faqValoriza.component';
import { MainComponent } from './public/main.component';
import { ChangePasswordComponent } from './home/changePassword.component';
import { ResetPasswordComponent } from './public/resetPassword.component';
import { SimuladorConsumoComponent } from './home/simuladorConsumo.component';
import { DomiciliacionFacturaComponent } from './home/domiciliacionFactura.component';
import { Routes } from '@angular/router';
import { RegisterComponent } from './public/register.component';
import { LoginComponent } from './public/login.component';
import { ContactComponent } from './home/contact.component';
import { HomeComponent } from './home/home.component';
import { AuthorizationGuard } from './authorization-guard';
import { DatosCorrespondenciaComponent } from './home/datoscorrespondencia.component';
import { ConsumofacturaComponent } from './home/consumofactura.component';
import { LecturaContadorComponent } from './home/lecturacontador.component';
import { FaqComponent } from './home/faq.component';
import { UsuarioComponent } from './home/usuario.component';
import { ContactpublicComponent } from './public/contactpublic.component';
import { FaqSoriaComponent } from './home/Faqs/faqSoria.component';
import { FaqGuadalaguaComponent } from './home/Faqs/faqGuadalagua.component';
import { DocumentosComponent } from './home/documentos.component';
import { EncuestasComponent } from './home/encuestas.component';
import { ReclamacionesComponent } from './home/reclamaciones.component';
import { TramitesComponent } from './home/tramites.component';

export const AppRoutes: Routes = [
    // { path: '', component:  LoginComponent },
    { path: 'public/login', component: LoginComponent },
    { path: 'home/home', component: HomeComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/contact', component: ContactComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'public/register', component: RegisterComponent },
    { path: 'home/datoscorrespondencia', component: DatosCorrespondenciaComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/consumofactura', component: ConsumofacturaComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/lecturacontador', component: LecturaContadorComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/faq', component: FaqComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/faqValoriza', component: FaqValorizaComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/faqSoria', component: FaqSoriaComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/faqGuadalagua', component: FaqGuadalaguaComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/changePassword', component: ChangePasswordComponent, pathMatch: 'full' },
    { path: 'public/resetPassword', component: ResetPasswordComponent },
    { path: 'home/domiciliacionFactura', component: DomiciliacionFacturaComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/usuario', component: UsuarioComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/simuladorConsumo', component: SimuladorConsumoComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/grafico', component: GraficoComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'public/contactpublic', component: ContactpublicComponent },
    { path: 'home/documentos', component: DocumentosComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/encuestas', component: EncuestasComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/reclamaciones', component: ReclamacionesComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] },
    { path: 'home/tramites', component: TramitesComponent, pathMatch: 'full', canActivate: [ AuthorizationGuard ] }
    // { path: '', redirectTo: 'public/login', pathMatch: 'full' },
    // { path: '**', redirectTo: 'public/login', pathMatch: 'full' }
];



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/application-routes.ts